import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

function containsPixelDataMissing(
  error,
  depth = 0,
  seen = new WeakSet()
) {
  if (!error || depth > 10) {
    return false;
  }
  if (typeof error === "string") {
    return error
      .toLowerCase()
      .includes("pixel data is missing");
  }
  if (
    typeof error !== "object" &&
    typeof error !== "function"
  ) {
    return false;
  }
  if (typeof error === "object") {
    if (seen.has(error)) {
      return false;
    }

    seen.add(error);
  }
  const directValues = [
    error.message,
    error.reason,
    error.statusText,
    error.description,
    error.errorMessage,
    error.status,
    error.name,
    error.code,
  ];

  for (const value of directValues) {
    if (
      typeof value === "string" &&
      value
        .toLowerCase()
        .includes("pixel data is missing")
    ) {
      return true;
    }
  }
  const nestedValues = [
    error.error,
    error.reason,
    error.detail,
    error.data,
    error.cause,
    error.response,
    error.originalError,
    error.innerError,
    error.exception,
  ];

  for (const value of nestedValues) {
    if (
      containsPixelDataMissing(
        value,
        depth + 1,
        seen
      )
    ) {
      return true;
    }
  }
  try {
    for (const key of Object.keys(error)) {
      const value = error[key];

      if (
        typeof value === "string" &&
        value
          .toLowerCase()
          .includes("pixel data is missing")
      ) {
        return true;
      }

      if (
        value &&
        typeof value === "object" &&
        containsPixelDataMissing(
          value,
          depth + 1,
          seen
        )
      ) {
        return true;
      }
    }
  } catch (inspectionError) {
    // Ignore inspection errors.
    // Never let the error handler itself crash.
  }

  return false;
}
const originalConsoleError = console.error;
console.error = function (...args) {
  const hasPixelDataError = args.some((arg) => containsPixelDataMissing(arg));

  if (hasPixelDataError) {
    console.warn("[PACS Suppressed Cache Error]:", ...args);
    return;
  }

  originalConsoleError.apply(console, args);
};

function logUnhandledRejection(reason) {
  console.group("[PACS] Unhandled Promise Rejection");

  console.log("Raw reason:", reason);

  if (
    reason &&
    typeof reason === "object"
  ) {
    try {
      console.log(
        "Keys:",
        Object.keys(reason)
      );
    } catch (error) {
      console.log(
        "Could not read object keys:",
        error
      );
    }

    try {
      console.log(
        "JSON:",
        JSON.stringify(
          reason,
          Object.getOwnPropertyNames(reason),
          2
        )
      );
    } catch (error) {
      console.log(
        "Could not stringify reason:",
        error
      );
    }
  }

  console.groupEnd();
}

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;

    logUnhandledRejection(reason);

    const isPixelDataError =
      containsPixelDataMissing(reason);

    if (isPixelDataError) {
      console.warn(
        "[PACS] Ignoring known DICOM error: Pixel Data is missing.",
        reason
      );

      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    originalConsoleError(
      "[PACS] Unhandled Promise Rejection:",
      reason
    );
  },
  true
);

window.addEventListener(
  "error",
  (event) => {
    const errorObject =
      event.error || event.message;

    console.group("[PACS] Global Error");
    console.log("message:", event.message);
    console.log("error:", event.error);
    console.log("filename:", event.filename);
    console.log("line:", event.lineno);
    console.log("column:", event.colno);
    console.groupEnd();

    const isPixelDataError =
      containsPixelDataMissing(errorObject);

    if (isPixelDataError) {
      console.warn(
        "[PACS] Ignoring known DICOM error: Pixel Data is missing.",
        errorObject
      );

      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    originalConsoleError(
      "[PACS] Unhandled JavaScript error:",
      errorObject
    );
  },
  true
);

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <App />
);

reportWebVitals();